import { useContext } from "react";
import { AuthContext } from "../context/UserContext";

function useAuth() {
  const auth = useContext(AuthContext);
  return { ...auth, isAuthenticated: auth.user != null };
}

export default useAuth;
